<template>
    <Card :title="translate('labels.bank_details_page.bank_detail')">
        <div class="card-body">
            <div class="row">
                <div class="col-lg-3">
                    <FormGroup :label="$t('labels.name')" type="text" :required="true">
                        <Input v-model="bankDetail.name" type="text"/>
                    </FormGroup>
                </div>
                <div class="col-lg-3">
                    <FormGroup :label="$t('labels.name_in_document')" type="text" :required="true">
                        <Input v-model="bankDetail.nameInDocument" type="text"/>
                    </FormGroup>
                </div>
                <div class="col-lg-3">
                    <FormGroup :label="$t('labels.code')" type="text" :required="true">
                        <Input v-model="bankDetail.code" type="text"/>
                    </FormGroup>
                </div>
                <div class="col-lg-3">
                    <FormGroup :label="$t('labels.iban')" type="text" :required="true">
                        <Input v-model="bankDetail.iban" type="text"/>
                    </FormGroup>
                </div>
                <div class="col-lg-3">
                    <FormGroup :label="$t('labels.bank_name')" type="text" :required="true">
                        <Input v-model="bankDetail.bankName" type="text"/>
                    </FormGroup>
                </div>
                <div class="col-lg-3">
                    <FormGroup :label="$t('labels.address')" type="text" :required="true">
                        <Input v-model="bankDetail.address" type="text"/>
                    </FormGroup>
                </div>
                <div class="col-lg-3">
                    <FormGroup :label="$t('labels.phone')" type="text" :required="true">
                        <Input v-model="bankDetail.phone" type="text"/>
                    </FormGroup>
                </div>
                <div class="col-lg-3">
                    <FormGroup :label="$t('labels.email')" type="text" :required="true">
                        <Input v-model="bankDetail.email" type="text"/>
                    </FormGroup>
                </div>
            </div>
        </div>
        <div class="card-footer d-flex justify-content-end">
            <AppButton size="sm" color="light" @click="remove" class="mr-2">
                <span>{{ translate('buttons.delete') }}</span>
            </AppButton>
            <AppButton size="sm" color="teal" @click="update">
                <span>{{ translate('buttons.edit') }}</span>
            </AppButton>
        </div>
    </Card>
</template>
<script>
import Card from '../../../../components/new/CardComponent.vue';
import AppButton from '../../../../components/new/button/AppButton.vue';
import FormGroup from "../../../../components/new/form/group/FormGroup.vue";
import Input from "../../../../components/new/form/Input.vue";

import MessageNotificator from '../../../../services/MessageNotificator';
import { BankDetailApi } from '../../../api/BankDetailApi';

export default {
    name: "EditBankDetail",
    components: {
        Card, AppButton, FormGroup, Input
    },
    data() {
        return {
            bankDetail: {
                name: "",
                nameInDocument: "",
                code: "",
                iban: "",
                bankName: "",
                address: "",
                phone: "",
                email: ""
            }
        }
    },
    methods: {
        fetchBankDetail() {
            BankDetailApi.find(this.$route.params.bankDetailUuid).then((response) => {
                this.bankDetail = response
            })
        },
        async update() {
            let request = {
                name: this.bankDetail.name,
                name_in_document: this.bankDetail.nameInDocument,
                code: this.bankDetail.code,
                iban: this.bankDetail.iban,
                bank_name: this.bankDetail.bankName,
                address: this.bankDetail.address,
                phone: this.bankDetail.phone,
                email: this.bankDetail.email
            }

            BankDetailApi.edit(request, this.$route.params.bankDetailUuid).then(() => {
                new MessageNotificator().success(this.$t("alerts.success"))
            })
        },
        async remove() {
            
            new MessageNotificator().confirm(this.$t('alerts.delete_bank_detail'), () => {
                BankDetailApi.remove(this.$route.params.bankDetailUuid).then(() => {
                    this.$router.replace({
                        name: "IndexBankDetailsPage"
                    })
                })
            })
        }
    },
    mounted() {
        this.fetchBankDetail()
    }
}
</script>
